"use client";

import * as React from "react";
import { ShieldCheck, Leaf, Lock } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const policies = [{
  id: 1,
  title: "Seismic Reinforcement",
  description: "Our steel-reinforced concrete decks are engineered to meet and exceed California's strict seismic codes, ensuring your safety in every season and environment.",
  icon: ShieldCheck
}, {
  id: 2,
  title: "Maximum Load Bearing",
  description: "Designed for heavy-duty applications, our structural decks provide the rock-solid foundation needed for hot tubs, stone masonry, and expansive outdoor living.",
  icon: Lock
}, {
  id: 3,
  title: "Concrete Longevity",
  description: "Utilizing professional-grade waterproofing and high-strength concrete, we build structures that resist moisture and salt air for decades of maintenance-free use.",
  icon: Leaf
}];
export default function PoliciesCertifications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="210990" id="structural-deck-benefits" className="py-24 bg-secondary text-secondary-foreground">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-default text-white tracking-tight">
            Structural Engineering Excellence
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            As premier California deck builders, we specialize in high-performance structural decks 
            engineered for seismic stability and lasting durability in coastal and hill regions.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {policies.map((policy, i) => {
          const Icon = policy.icon;
          return <Card key={policy.id} data-index={i} className="rounded-none shadow-none hover:shadow-xl hover:bg-secondary/50 transition-all duration-300 border-white/10 h-full flex flex-col bg-transparent backdrop-blur-sm">
                <CardHeader className="space-y-5 pb-4">
                  <Icon className="h-12 w-12 text-primary" strokeWidth={1} />
                  <CardTitle className="text-2xl font-bold font-default text-white">
                    {policy.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <CardDescription className="text-base font-medium text-muted-foreground font-default leading-relaxed">
                    {policy.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}